import {Component, Input, OnInit, ViewChild} from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';
import {SubReportComponent, SubReportElementComponent, SubReportFilter} from '../fields-interventions-general-ii-report.component';
import {UserDomainService} from '../../../../../user-domains/user-domain.service';
import {DxDataGridComponent} from 'devextreme-angular';
import {Workbook, Worksheet} from 'exceljs';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {filter as f, flatten, groupBy, map, sum} from 'lodash';
import {area, multiPolygon, polygon, union, difference, getCoords} from '@turf/turf';
import * as jsts from 'jsts';
import {Position} from 'geojson';

@Component({
  selector: 'app-operations-progress',
  templateUrl: './operations-progress.component.html',
  styleUrls: ['./operations-progress.component.scss'],
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportComponent.outputs,
})
export class OperationsProgressComponent extends SubReportComponent implements OnInit {
  @Input()
  index: any;

  @Input()
  store: ArrayStore;

  constructor(
    private userDomainsService: UserDomainService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.title = `${this.romainIndex}. L'AVANCEMENT DE L'EXECUTION DES OPERATIONS`;

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: workBook => this.export(workBook),
      loader: (isReload, filter, data) => this.load(isReload, filter, data)
    });
  }

  async load(isReload: boolean, filter: SubReportFilter, data): Promise<any> {

    const d = await Promise.all([
      this.userDomainsService.userDomainsWithAreas().toPromise(),
    ]);

    return super.load(isReload, filter, d);
  }

  getWorkSheetName(): string {
    return this.title;
  }

}

/* -----------------------------------------
-- Chart 1
-------------------------------------------- */
@Component({
  selector: 'app-operations-progress-chart-1',
  template: `
    <dx-accordion
      class="p-4"
      width="90%"
      [dataSource]="ds"
      [collapsible]="false"
      [multiple]="false"
      [animationDuration]="300">
      <div *dxTemplate="let d of 'title'">
        <h4 class="group-title">{{d.title}}</h4>
      </div>
      <div *dxTemplate="let d of 'item'">
        <div class="flex flex-row">
          <dx-circular-gauge
            class="p-2"
            *ngFor="let dd of d.data" [value]="dd.Avancement"
            [size]="{width: 320,  height: 300}">
            <dxo-scale
              [startValue]="0"
              [endValue]="100"
              [tickInterval]="10">
              <dxo-label [customizeText]="customizeText"></dxo-label>
            </dxo-scale>
            <dxo-range-container>
              <dxi-range [startValue]="0" [endValue]="20" color="#CE2029"></dxi-range>
              <dxi-range [startValue]="20" [endValue]="50" color="#FFD700"></dxi-range>
              <dxi-range [startValue]="50" [endValue]="100" color="#228B22"></dxi-range>
            </dxo-range-container>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-title [text]="dd.Operation" [subtitle]="{text: dd.AvancementTitle, font: {size:18, weight:300}}">
              <dxo-font [size]="20" [weight]="300" color="black"></dxo-font>
            </dxo-title>
          </dx-circular-gauge>
        </div>
      </div>
    </dx-accordion>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class OperationsProgressChart1Component extends SubReportElementComponent implements OnInit {

  ds = [];

  constructor() {
    super();
  }

  ngOnInit(): void {

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, ff, data) => this.load(isReload, ff, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    /*workSheet.mergeCells(workSheet.rowCount, 1, workSheet.rowCount, 10);
    return exportDataGrid({
      component: this.grid.instance,
      worksheet: workSheet,
      customizeCell: ({excelCell, gridCell}) => {

      },
      topLeftCell
    });*/
    return Promise.resolve(undefined);
  }

  load(isReload: boolean, filter, [domains]) {
    const reader = new jsts.io.GeoJSONReader();
    const hasMultipleDomains = filter.domains.length > 1;
    const ids = filter.domainIds();
    const interventions = f(this.store.createQuery().toArray(), i => ids.indexOf(i.field.domain_id) !== -1);
    this.ds = map(groupBy(interventions, 'domain_name'), (g, domainName) => {
      const domain = domains.find((d) => d.name === domainName);
      if (!domain) {
        return {};
      }
      return {
        domain: domain.name,
        title: domainName + ': Avancement des Opérations Agricoles',
        data: map(groupBy(g, 'trailer_operation_type'), (gg, operation) => {
          /* const totalDoneArea = sum(map(groupBy(g, 'field.id'), (ggg) => {
             return area(ggg.reduce((all, item) => {
               return union(all, feature(item.working_multipolygon_geojson));
             }, multiPolygon([])));
           }));*/
          /*map(groupBy(gg, int => int.field.id), (fff) => fff).forEach((fieldsGroup) => {
            for (let i = 0; i < fieldsGroup.length; i++) {
              const f1 = reader.read(fieldsGroup[i].working_multipolygon_geojson);
              for (let j = i + 1; j < fieldsGroup.length; j++) {
                const f2 = reader.read(fieldsGroup[j].working_multipolygon_geojson);

                if (f1.intersects(f2)) {
                  const diff = f1.difference(f2);
                }
              }
            }
          });*/
          /*map(groupBy(gg, int => int.field.id), (fff) => fff).forEach((fieldsGroup) => {
            for (let i = 0; i < fieldsGroup.length; i++) {
              const coords1 = fieldsGroup[i].working_multipolygon_geojson.coordinates;
              const f1 = multiPolygon(coords1);
              console.log(getCoords(f1));
              for (let j = i + 1; j < fieldsGroup.length; j++) {
                const coords2 = fieldsGroup[j].working_multipolygon_geojson.coordinates;
                const f2 = multiPolygon(coords2);

                if (booleanIntersects(f1, f2)) {
                  const diff = difference(f1, f2);
                }
              }
            }
          });*/


          const totalDoneArea = gg.reduce((s, item) => {
            return s + item.working_area_ha;
          }, 0);


          return {
            Operation: operation,
            AvancementTitle: totalDoneArea.toFixed(2) + '/' + domain.total_area.toFixed(2) + ' (Ha)',
            Avancement: 100 * totalDoneArea / domain.total_area,
          };
        })
      };
    });

    if (hasMultipleDomains) {
      const totalArea = domains.reduce((s, item) => {
        return s + item.total_area;
      }, 0);
      this.ds.unshift({
        domain: 'Total',
        title: 'Total: Avancement des Opérations Agricoles',
        data: map(groupBy(interventions, 'trailer_operation_type'), (gg, operation) => {
          const totalDoneArea = gg.reduce((s, item) => {
            return s + item.working_area_ha;
          }, 0);
          return {
            Operation: operation,
            AvancementTitle: totalDoneArea.toFixed(2) + '/' + totalArea.toFixed(2) + ' (Ha)',
            Avancement: 100 * totalDoneArea / totalArea,
          };
        })
      });
    }

    return Promise.resolve(undefined);
  }

  customizeText(arg: any) {
    return arg.valueText + ' %';
  }
}
